<template>
	<v-app :style="cssVars">
		<component v-if="!!layout" :is="layout">
			<router-view></router-view>
		</component>
		<div v-else>Loading...</div>
	</v-app>
</template>

<script>
import GuestLayout from './components/Layouts/GuestLayout'
import AppLayout from './components/Layouts/AppLayout'
import { mapGetters } from 'vuex'
export default {
	name: 'App',
	components: {
		GuestLayout,
		AppLayout,
	},
	computed: {
		...mapGetters('settings', ['web', 'ci_cd', 'styles']),

		layout() {
			const layout = [...this.$route.matched]
				.filter((route) => route.meta.layout)
				.map((route) => route.meta.layout)
				.reverse()
				.shift()
			return layout ? `${layout}-layout` : 'guest-layout'
		},
		cssVars() {
			const {
				navigation_bar_tint: navigationBarTint,

				button_secondary_background: buttonSecondaryBgc,
				button_secondary: buttonSecondaryText,

				button_main_background: buttonMainBgc,
				button_main: buttonMainText,
				chip_text_normal: chipTextNormal,
				chip_text_selected: chipTextSelected,
				chips_normal_background: chipNormalBackground,
				chips_selected_background: chipSelectedBackground,
				badge_pin_background: badgePinBackground,
				badge_sponsored_background: badgeSponsoredBackground
			} = this.styles || {}

			let prepareMainBgcButton = buttonMainBgc

			if (buttonMainBgc === buttonSecondaryBgc) {
				prepareMainBgcButton = navigationBarTint
			}

			return {
				'--accent-color': navigationBarTint,

				'--button-main-background-color': prepareMainBgcButton,
				'--button-main-color': buttonMainText,

				'--button-secondary-background-color': buttonSecondaryBgc,
				'--button-secondary-color': buttonSecondaryText,

				'--chip-text-normal': chipTextNormal,
				'--chip-text-selected': chipTextSelected,
				'--chip-normal-background': chipNormalBackground,
				'--chip-selected-background': chipSelectedBackground,

				'--badge-pin-background': badgePinBackground,
				'--badge-sponsored-background': badgeSponsoredBackground
			}
		}
	},
	watch: {
		web() {
			const {favicon_image: favicon} = this.web;
			this.updateFavicon(favicon)
		},
		ci_cd() {
			const {device_name: cloneTitle} = this.ci_cd;
			this.changeTitle(cloneTitle)
		},
	},
	created() {
		// test
	},
	methods: {
		changeTitle(title) {
			document.title = title;
		},

		updateFavicon(newFavicon) {
			this.favicon = newFavicon;

			const faviconLink = document.querySelector("link[rel='icon']");

			if (faviconLink) {
				faviconLink.href = newFavicon;
			}
		},
	}
}
</script>

<style></style>
